import * as React from 'react';
import { useContext } from 'react';

import type { NavButtonType } from 'bundles/page-header/components/mobile/constants';

export type PageHeaderContextType = {
  isSimplifiedPageHeader?: boolean;
  subNavigationLinks?: React.ReactNode;
  pageHasBackdrop?: boolean;
  updatePageHasBackdrop?: (hasBackdrop: boolean) => void;
  hasUnifiedMetaNav?: boolean;
  mobileSubNavigationLinks?: NavButtonType[];
};

const PageHeaderContext = React.createContext<PageHeaderContextType>({});

export const useMobileSubNavigationLinks = () => {
  return useContext(PageHeaderContext).mobileSubNavigationLinks;
};

export const useIsSimplifiedPageHeader = () => {
  return useContext(PageHeaderContext).isSimplifiedPageHeader;
};

export const useHasMetaNav = () => {
  return useContext(PageHeaderContext).hasUnifiedMetaNav;
};

export const usePageHeader = () => {
  return useContext(PageHeaderContext);
};

export default PageHeaderContext;
